import React from 'react';

interface StarRatingProps {
  rating: number;
  showCount?: boolean;
  count?: number;
  className?: string;
}

const StarRating: React.FC<StarRatingProps> = ({ rating, showCount = false, count, className = '' }) => {
  // Ensure rating is a valid number between 0-5
  const displayRating = Math.min(Math.max(Number(rating) || 0, 0), 5);
  // Ensure count is a valid non-negative number
  const displayCount = Math.max(Number(count) || 0, 0);

  return (
    <div className={`flex items-center ${className}`}>
      <div className="flex items-center">
        {[...Array(5)].map((_, i) => {
          const fullStar = i < Math.floor(displayRating);
          const halfStar = !fullStar && i < Math.ceil(displayRating) && (displayRating % 1) >= 0.5;
          
          return (
            <span
              key={`star-${i}`}
              className={`text-lg ${
                fullStar || halfStar ? 'text-yellow-400' : 'text-gray-300'
              }`}
            >
              {fullStar ? '★' : halfStar ? '★' : '☆'}
            </span>
          );
        })}
      </div>
      {showCount && (
        <span className="ml-2 text-gray-600">
          {displayRating.toFixed(1)} {displayCount > 0 && `(${displayCount} ${displayCount === 1 ? 'review' : 'reviews'})`}
        </span>
      )}
    </div>
  );
};

export default StarRating; 